import { useState, useEffect } from 'react';

interface PerformanceMemory {
  usedJSHeapSize: number;
  totalJSHeapSize: number;
  jsHeapSizeLimit: number;
}

function readHeap(): number | null {
  try {
    const perf = performance as Performance & { memory?: PerformanceMemory };
    if (perf.memory && typeof perf.memory.usedJSHeapSize === 'number') {
      return perf.memory.usedJSHeapSize;
    }
  } catch {
    // not available
  }
  return null;
}

export function useMemoryUsage(poll: boolean): number | null {
  const [bytes, setBytes] = useState<number | null>(readHeap());

  useEffect(() => {
    setBytes(readHeap());
    if (!poll) return;
    const id = setInterval(() => setBytes(readHeap()), 1000);
    return () => clearInterval(id);
  }, [poll]);

  return bytes;
}

export function isMemoryApiAvailable(): boolean {
  return readHeap() !== null;
}
